export async function productGetImageUseCase(product_id, externalShipmentRepository) {
    const result = await externalShipmentRepository.get_product_image(product_id);
   
    return result;
}